import { Box } from '@mui/material';
import { ItemStats } from './ItemStats';
import { ItemCard, ItemIdentity } from './ui/ItemCard';
import { getItemImageUrl } from '../utils/itemUtil';

export const Item = ({ item, showStats = true, titleComponent = 'h3' }) => {
  return (
    <ItemCard imageUrl={getItemImageUrl(item)} imageAlt={item.name ? `Image for ${item.name}` : ''} mediaResetKey={item.id}>
      <ItemIdentity item={item} titleComponent={titleComponent} />
      {showStats ? <Box sx={{ mt: '15px' }}><ItemStats item={item} /></Box> : null}
    </ItemCard>
  );
};
